import { observer } from 'mobx-react-lite';

import { company } from '~/company/Company';
import { useStores } from '~/hooks/useStore';
import styles from './ShopV3SaasSidebar.module.scss';
import ShopV3SaasSidebarItem from './ShopV3SaasSidebarItem';

const ShopV3SaasSidebar = () => {
  const { shopCategories } = useStores();
  const categories = shopCategories.list.flatMap(
    ({ subcategory }) => subcategory,
  );

  return (
    <div className={styles.container} data-company={company.name}>
      {categories.map((category) => (
        <ShopV3SaasSidebarItem key={category.id} category={category} />
      ))}
    </div>
  );
};

export default observer(ShopV3SaasSidebar);
